import React from "react";
import { Box, IconButton } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp"; 

export const BotonFlotante = () => {
  const handleClick = () => {
    window.open("https://wa.me/+5492396416909", "_blank"); 
  };

  return (
    <Box
    sx={{
      position: "fixed",
      bottom: 16,
      right: 16,
      zIndex: 1000,
      width: "50px", 
      height: "50px",
      "@media (max-width: 768px)": {
        width: "40px", 
        height: "40px",
      },
    }}
  >
    <IconButton onClick={handleClick} sx={{ backgroundColor: "#25D366", color: "white" }}>
      <WhatsAppIcon fontSize="large" />
    </IconButton>
  </Box>
  );
};


